import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { api, errorTreatment } from "../../../../../services/api";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import "../../style.css";
import { ChartBar } from "./chart";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";

export interface Routes {
  data: {
    eta: {
      route: string;
      time: number;
    }[];
    count: number;
    max: number;
    min: number;
  };
}

export const ChartPunctualSuperDelayed = () => {
  const { changeVisibility } = useContext(LoadingContext);
  const { reloadComponent } = useContext(DashboardContext);
  const { shortToken , id, mode } = useParams();
  const { hasShortToken} = useContext(AuthContext);

  let routeRoutes: string;
  const [routes, setRoutes] = useState<Routes["data"]>({
    eta: [{ route: "", time: 0 }],
    count: 0,
    max: 0,
    min: 0,
  });
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (hasShortToken) {
    routeRoutes = `/punctualities/eta?graphic_id=chartPunctualSuperDelayed&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeRoutes = `/punctualities/eta?graphic_id=chartPunctualSuperDelayed&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeRoutes)
      .then((routes: Routes) => {
        setRoutes(routes.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return completeRequisition && !reloadComponent ? (
    <div id="chart-punctual-super-delayed" className="h100">
      <ChartBar data={routes} />
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
